export default __webpack_public_path__ + "static/media/fphl.27896e4b.JPG";